<template>
  <basic-container class="region">
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  regionSelections,
  add,
  getDetail,
  getList,
  beforeDelete,
  remove,
  update,
} from '@/api/v4ward/park/region/parkregion';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      operateType: '',
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        align: 'center',
        indexLabel: '序号',
        dialogWidth: '30%',
        labelWidth: 120,
        span: 24,
        column: [
          {
            label: '停车场',
            prop: 'parkingLotId',
            type: 'select',
            dicUrl: '/api/parking/lot/selections',
            editDisabled: true,
            search: true,
            props: {
              label: 'parkingLotName',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
          },
          {
            label: '上级区域',
            prop: 'parentRegionId',
            editDisabled: true,
            type: 'tree',
            //dicUrl: '/api/park/region/selections',
            dicData: [],
            props: {
              label: 'title',
              value: 'id',
            },
            hide: true,
          },
          {
            label: '区域名称',
            prop: 'regionName',
            maxlength: 32,
            rules: [
              {
                required: true,
                message: '请输入区域名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '区域编号',
            prop: 'regionCode',
            maxlength: 32,
            rules: [
              {
                required: true,
                message: '请输入区域编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车位数',
            prop: 'parkingSpaceCount',
            type: 'number',
            rules: [
              {
                required: true,
                message: '请输入车位数',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            maxlength: 128,
            minRows: 2,
          },
        ],
      },
      data: [],
    };
  },
  activated() {
    let self = this;
    setTimeout(() => {
      this.$refs.crud.doLayout(); //解决表格错位
    }, 0);
  },
  mounted() {
    let self = this;
    setTimeout(() => {
      window.addEventListener(
        'resize',
        () => {
          self.$refs.crud.doLayout(); //窗口缩放解决表格错位
        },
        false
      );
    }, 0);
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkregion_add, true),
        viewBtn: this.vaildData(this.permission.parkregion_view, false),
        delBtn: this.vaildData(this.permission.parkregion_delete, true),
        editBtn: this.vaildData(this.permission.parkregion_edit, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  watch: {
    'form.parkingLotId'() {
      this.loadRegionSelections(this.form.parkingLotId);
    },
  },
  methods: {
    loadRegionSelections(parkId) {
      regionSelections({ parkId: parkId }).then((res) => {
        if (this.operateType === 'add') {
          this.form.parentRegionId = null;
        }
        const column = this.findObject(this.option.column, 'parentRegionId');
        column.dicData = res.data;
      });
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      beforeDelete({ id: row.id }).then((res) => {
        if (res.data) {
          this.$alert('检测到区域有关联数据，请先删除关联信息！', {
            confirmButtonText: '确定',
            type: 'warning',
          });
        } else {
          this.$confirm('确定将选择数据删除?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              return remove({ id: row.id });
            })
            .then(() => {
              this.onLoad();
              this.$message.success('操作成功!');
            });
        }
      });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style>
</style>
